/**
 * Поверхностное сравнение двух массивов — одинаковая длина и строгое равенство элементов.
 * @param {Array} a - Первый массив.
 * @param {Array} b - Второй массив.
 * @returns {boolean} true, если массивы равны.
 */
const isArrayEqual = (a, b) => a?.length === b?.length && a.every((v, i) => v === b[i]);

export default isArrayEqual;
